import { createSlice, createEntityAdapter } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'

import { getTechRegions } from './api'
import type { TechRegionModel } from './typings'

const techRegionEntityAdapter = createEntityAdapter<TechRegionModel>()

export const initialState = techRegionEntityAdapter.getInitialState({
  count: 0,
  skip: 0,
  take: 0,
})

const techRegionSlice = createSlice({
  name: 'techRegions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTechRegions.fulfilled, (state, { payload }) => {
      const { count, skip, take, items } = payload

      state.count = count
      state.skip = skip
      state.take = take

      techRegionEntityAdapter.setAll(state, items ?? [])
    })
  },
})

export default techRegionSlice.reducer

export const { selectAll: selectAllTechRegions } =
  techRegionEntityAdapter.getSelectors<StoreData>((state) => state.techRegions)
